import React from "react";
import {t} from "../../../helpers/translator";

export default function lockTerminalTemplate () {
    return <div className="dms-success-popup">
        <div className="title-popup-page-m-dms">
            {this.props.title && <p className='auth-popup-title'>{t(this.props.title)}</p>}
            <button className="popup-closed-b" onClick={this.registerPopupForDms()} />
        </div>
        <div className="ticket-results-view-p">
            <p>{t(this.props.body)}</p>
            <i className="success-pu" />
            <div className="buttons-view-w-t">
                <div className="separator-box-buttons-m-wrap">
                    <div className="separator-box-buttons-m auth-full-width-button">
                        <button className="button-view-normal-m trans-m"
                                onClick={this.registerPopupForDms()}>
                            {t("Done")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
